(function () {
  'use strict';

  var sty = document.createElement('style');
  sty.textContent = '.vntg-size-hidden{display:none!important}';
  (document.head || document.documentElement).appendChild(sty);

  var SIZE_NAMES = ['maat', 'size', 'grootte', 'taille'];
  var SIZE_TOKENS = ['xxl', 'xl', 'xxs', 'xs', 'l', 'm', 's'];
  var cache = {};
  var currentProductData = null;
  var debounceTid = null;

  // Vergroot de aanbevelingenpool voordat product-recommendations.js laadt
  document.querySelectorAll('product-recommendations[data-url]').forEach(function (el) {
    var url = el.getAttribute('data-url') || '';
    if (/[?&]limit=/.test(url)) {
      el.setAttribute('data-url', url.replace(/([?&]limit=)\d+/, '$124'));
    }
  });

  function expandSize(str) {
    var result = new Set();
    str.toLowerCase().trim().split(/[\/\-\s]+/).forEach(function (part) {
      part = part.trim();
      if (!part) return;
      if (SIZE_TOKENS.indexOf(part) !== -1) { result.add(part); return; }
      var rem = part, found = [], max = 4;
      while (rem.length > 0 && max-- > 0) {
        var matched = false;
        for (var i = 0; i < SIZE_TOKENS.length; i++) {
          if (rem.startsWith(SIZE_TOKENS[i])) {
            found.push(SIZE_TOKENS[i]); rem = rem.slice(SIZE_TOKENS[i].length); matched = true; break;
          }
        }
        if (!matched) { result.add(rem); break; }
      }
      found.forEach(function (t) { result.add(t); });
    });
    return result;
  }

  function sizeMatches(a, b) {
    var ea = expandSize(a), eb = expandSize(b), hit = false;
    ea.forEach(function (t) { if (eb.has(t)) hit = true; });
    return hit;
  }

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d) cache[handle] = d; return d; })
      .catch(function () { return null; });
  }

  function getSize() {
    var picker = document.querySelector('variant-selects');
    if (picker) {
      var radios = picker.querySelectorAll('input[type="radio"]:checked');
      for (var i = 0; i < radios.length; i++) {
        var nm = (radios[i].getAttribute('name') || '').toLowerCase();
        if (SIZE_NAMES.some(function (n) { return nm.includes(n); })) return radios[i].value;
      }
    }
    if (currentProductData) {
      var vid = new URLSearchParams(window.location.search).get('variant');
      if (vid) {
        var v = currentProductData.variants.find(function (v) { return String(v.id) === vid; });
        if (v) {
          var opts = currentProductData.options || [];
          var idx = opts.findIndex(function (o) { return SIZE_NAMES.some(function (n) { return o.toLowerCase().includes(n); }); });
          if (idx < 0) idx = 0;
          return v.options ? v.options[idx] : v['option' + (idx + 1)];
        }
      }
      var fv = currentProductData.variants.find(function (v) { return v.available; }) || currentProductData.variants[0];
      if (fv) {
        var opts2 = currentProductData.options || [];
        var idx2 = opts2.findIndex(function (o) { return SIZE_NAMES.some(function (n) { return o.toLowerCase().includes(n); }); });
        if (idx2 < 0) idx2 = 0;
        return fv.options ? fv.options[idx2] : fv['option' + (idx2 + 1)];
      }
    }
    return null;
  }

  function getContainer() {
    return document.querySelector('.related-products') || document.querySelector('.complementary-products');
  }

  function getWrap(card) {
    return card.closest('.f-column') || card.closest('li') || card.closest('.swiper-slide') || card;
  }

  var SHOW_LIMIT = 8;

  function runSync() {
    var size = getSize();
    var container = getContainer();
    var cards = container ? Array.prototype.slice.call(container.querySelectorAll('.product-card')) : [];
    if (!size || !container || !cards.length) return;

    var matching = [], nonMatching = [];
    cards.forEach(function (card) {
      var sizeEl = card.querySelector('.vntg-pcard-size');
      var cardSize = sizeEl ? sizeEl.textContent.trim() : '';
      if (!cardSize || sizeMatches(size, cardSize)) {
        matching.push(card);
      } else {
        nonMatching.push(card);
      }
    });

    var fillCount = Math.max(0, SHOW_LIMIT - matching.length);

    matching.forEach(function (card, i) {
      var wrap = getWrap(card);
      wrap.classList.remove('vntg-size-hidden');
      wrap.style.order = String(i);
    });

    nonMatching.forEach(function (card, i) {
      var wrap = getWrap(card);
      if (i < fillCount) {
        wrap.classList.remove('vntg-size-hidden');
        wrap.style.order = String(100 + i);
      } else {
        wrap.classList.add('vntg-size-hidden');
        wrap.style.order = '';
      }
    });
  }

  function doSync() {
    clearTimeout(debounceTid);
    debounceTid = setTimeout(runSync, 60);
  }

  document.querySelectorAll('product-recommendations').forEach(function (el) {
    el.addEventListener('recommendations:loaded', doSync);
    new MutationObserver(function (mutations) {
      if (mutations.some(function (m) { return m.addedNodes.length > 0; })) doSync();
    }).observe(el, { childList: true });
  });

  document.addEventListener('variant:change', doSync);
  document.addEventListener('change', function (e) {
    if (e.target.closest('variant-selects')) doSync();
  });

  var hm = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (hm) {
    fetchProduct(hm[1]).then(function (data) {
      currentProductData = data;
      doSync();
    });
  }

  setTimeout(doSync, 2000);
  setTimeout(doSync, 5000);
})();
